// @ts-nocheck
/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './schema-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
export * from './schema-types';
const defaultOptions = {} as const;
export type AiAlarmsCountQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  dataFilter?: Types.DataQueryFiltersInput | null | undefined;
}>;


export type AiAlarmsCountQuery = { alarmsCount: { active: { count: number, findings: number }, inactive: { count: number, findings: number } } };

export type AiAlarmsQueryVariables = Exact<{
  filters: Types.AlarmsFilterInput;
}>;


export type AiAlarmsQuery = { alarms: Array<{ id: string, ruleId: string, type: Types.AlarmType, isActive: boolean, severity: Types.Severity, hasFindings: boolean, date: any, system: Types.SystemsType | null, ruleLogicType: Types.RuleLogicType | null, ruleLogicCategory: Types.RuleLogicCategoryType | null, spaces: Array<{ id: string, name: string, type: Types.SpaceType }>, installations: Array<{ id: string, name: string, type: string, category: string, parentId: string | null, controlLoop: { id: string, name: string, type: Types.PointsType } | null }> }> };

export type AiAlarmDurationsQueryVariables = Exact<{
  where: Types.AlarmsFilterInput;
}>;


export type AiAlarmDurationsQuery = { alarmTimelineStatistics: { startDate: any, endDate: any, alarms: Array<{ type: Types.AlarmType, isActive: boolean, severity: Types.Severity, hasFindings: boolean, date: any, system: Types.SystemsType | null, ruleLogicType: Types.RuleLogicType | null, ruleLogicCategory: Types.RuleLogicCategoryType | null, spaces: Array<{ id: string, name: string, type: Types.SpaceType }>, installations: Array<{ id: string, name: string, type: string, category: string, parentId: string | null, controlLoop: { id: string, name: string, type: Types.PointsType } | null }>, timelineStatistics: { totalActiveDurationMinutes: number, totalAlertCount: number } | null }> } };

export type AiAlarmFindingsQueryVariables = Exact<{
  ruleId: string | number;
}>;


export type AiAlarmFindingsQuery = { findingsByRuleId: Array<{ id: string, analysis: string | null, followUpActions: string | null, createdAt: string, notifiedGroups: Array<string> | null, findingState: Types.FindingStateType | null, author: { id: string, name: string } }> | null };

export type AiAlarmFindingTimelineQueryVariables = Exact<{
  input: Types.FindingTimelineInput;
}>;


export type AiAlarmFindingTimelineQuery = { findingTimeline: { totalCount: number, items: Array<{ userId: string, userName: string, createdAt: any, type: Types.FindingTimelineType, context:
        | { id: string, text: string, createdAt: any }
        | { from: Types.FindingStateType, to: Types.FindingStateType }
        | Record<PropertyKey, never>
       }> } | null };

export type AiEnergyConsumptionQueryVariables = Exact<{
  dataFilters: Types.DataQueryFiltersInput;
  spaceId: string;
  spaceType: Types.SpaceType;
  dataType: Types.DataType;
  mediums: Array<Types.MediumType> | Types.MediumType;
  splitBy: Types.SplitByType;
}>;


export type AiEnergyConsumptionQuery = { energyDataByType: { selectedInterval: Types.AggregationIntervals, data: Array<{ unit: Types.CombinedUnit, data: Array<{ value: number, timeStamp: any }>, splitLabel: { mediumType: Types.MediumType | null, source: Types.SourceType | null, name: string | null } | null }> } };

export type AiEnergyMeterReadingsQueryVariables = Exact<{
  dataFilters: Types.DataQueryFiltersInput;
  spaceId: string;
  spaceType: Types.SpaceType;
  mediums: Array<Types.MediumType> | Types.MediumType;
  meterCategory: Types.MeterCategory;
  meterDataResultType: Types.MeterDataResultType;
  mode: Types.MeterDataMode;
}>;


export type AiEnergyMeterReadingsQuery = { energyMeterDataQuery: { meterData: Array<{ mediumType: Types.MediumType, unit: Types.CombinedUnit, datapointName: string, spaces: { site: { name: string } | null, building: { name: string } | null, subBuilding: { name: string } | null, level: { name: string } | null, room: { name: string } | null } | null, meter: { id: string, name: string }, data: Array<{ value: number, timeStamp: any }> }> } };

export type AiEnergyRegressionQueryVariables = Exact<{
  regressionWhere: Types.EnergyRegressionInput;
}>;


export type AiEnergyRegressionQuery = { energyRegressionQuery: { intervals: Array<Types.AggregationIntervals>, selectedInterval: Types.AggregationIntervals, series: Array<{ gap: number, data: Array<{ timestamp: any, value1: number, value2: number }> }> } };

export type AiIndoorClimateScoresQueryVariables = Exact<{
  dataFilters: Types.DataQueryFiltersInput;
  spaceId: string;
  spaceType: Types.SpaceType;
  scoreSpaceType: Types.SpaceType;
  scoreTypes: Array<Types.ScoreType> | Types.ScoreType;
  standardId?: number | null | undefined;
}>;


export type AiIndoorClimateScoresQuery = { spacesStatistics: Array<{ space: { id: string, name: string, type: Types.SpaceType }, spaces: Array<{ id: string, name: string, type: Types.SpaceType }>, scoreData: Array<{ scoreType: Types.ScoreType, average: number | null, min: number | null, max: number | null, aggregatedDataScoreInfo: { name: string, positionPercentage: number } | null }> }> };

export type AiIndoorClimateStandardsBySpaceQueryVariables = Exact<{
  spaceId: string;
}>;


export type AiIndoorClimateStandardsBySpaceQuery = { indoorClimateStandards: Array<{ standardId: number, key: string, name: string, indoorClimateStandardType: Types.IndoorClimateStandardType }> };

export type AiIndoorClimateScoreTimeseriesQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  aggregationScoreType: Types.ScoreType;
  dataFilters: Types.DataQueryFiltersInput;
  standardId?: number | null | undefined;
}>;


export type AiIndoorClimateScoreTimeseriesQuery = { scoreTimeseriesBySpace: { timeseriesInfos: Array<{ timeseriesId: string, data: Array<{ timestamp: any, value: number, valueMin: number, valueMax: number, valueCount: number, aggregatedDataScoreInfo: { positionPercentage: number, name: string } }>, scoreThresholdInfoSet: { displayUnit: string, scoreThresholdInfos: Array<{ hexColor: string, start: number, startPercentage: number, end: number, endPercentage: number, name: string }> } }> } };

export type AiInstallationSystemsScoreQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  dataFilters: Types.DataQueryFiltersInput;
}>;


export type AiInstallationSystemsScoreQuery = { systemsScoreBySpace: Array<{ systemType: Types.SystemsType, score: number | null }> };

export type AiInstallationSystemsListQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  systemTypes: Array<Types.SystemsType> | Types.SystemsType;
  dataFilters: Types.DataQueryFiltersInput;
}>;


export type AiInstallationSystemsListQuery = { systemsOrSubsystemsScoreBySpace: Array<{ systemType: Types.SystemsType, score: number | null, system: { id: string, name: string, type: Types.SystemsType }, subsystem: { id: string, name: string, type: Types.SubsystemsType } | null, spaces: Array<{ id: string, name: string }> }> };

export type AiInstallationPartsScoresQueryVariables = Exact<{
  system: Types.SystemInput;
  subsystem?: Types.SubsystemInput | null | undefined;
  dataFilters: Types.DataQueryFiltersInput;
}>;


export type AiInstallationPartsScoresQuery = { systemOrSubsystemInstallationPartsScores: Array<{ category: Types.CategoryType, installationPartScores: Array<{ value: number | null, installationPart:
        | { id: string, name: string, points: Array<{ id: string, name: string, type: Types.PointsType, timeseriesId: string, metadata: Array<{ objectName: string | null, description: string | null, deviceInstance: number | null, objectType: string | null, objectInstance: number | null, protocolType: Types.ProtocolType }> | null }> }
        | { id: string, name: string, equipmentType: Types.EquipmentType, points: Array<{ id: string, name: string, type: Types.PointsType, timeseriesId: string }> }
        | { timeseriesId: string, isOnline: boolean | null, id: string, name: string, pointType: Types.PointsType, metadata: Array<{ objectName: string | null, description: string | null, deviceInstance: number | null, objectType: string | null, objectInstance: number | null, unitText: string | null, protocolType: Types.ProtocolType }> | null }
      , scores: Array<{ scoreType: Types.ScoreType, value: number | null }> }> }> };

export type AiSensorTimeseriesQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  sensorType: Types.PointsType;
  dataFilters: Types.DataQueryFiltersInput;
}>;


export type AiSensorTimeseriesQuery = { sensorTimeseriesBySpaceAndType: { spaceTimeseriesInfos: Array<{ space: { id: string, name: string }, data: Array<{ timestamp: any, value: number }> }> } };

export type AiSpaceListQueryVariables = Exact<{ [key: string]: never; }>;


export type AiSpaceListQuery = { spaceTree: Array<{ id: string, name: string, parentId: string | null, type: Types.SpaceType }> };

export type EmissionsDataQueryVariables = Exact<{
  dataFilters: Types.DataQueryFiltersInput;
  spaceId: string;
  spaceType: Types.SpaceType;
  dataType: Types.DataType;
  mediums: Array<Types.MediumType> | Types.MediumType;
  splitBy: Types.SplitByType;
}>;


export type EmissionsDataQuery = { energyDataByType: { data: Array<{ unit: Types.CombinedUnit, data: Array<{ value: number, timeStamp: any }> }> } };

export type EnergyGenerationDataQueryVariables = Exact<{
  dataFilters: Types.DataQueryFiltersInput;
  spaceId: string;
  spaceType: Types.SpaceType;
  dataType: Types.DataType;
  mediums: Array<Types.MediumType> | Types.MediumType;
  splitBy: Types.SplitByType;
}>;


export type EnergyGenerationDataQuery = { energyDataByType: { data: Array<{ unit: Types.CombinedUnit, data: Array<{ value: number }>, splitLabel: { mediumType: Types.MediumType | null, source: Types.SourceType | null, name: string | null } | null }> } };

export type AlarmsFindingsQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  limit: number;
}>;


export type AlarmsFindingsQuery = { alarmsCount: { active: { count: number, findings: number } }, alarms: Array<{ severity: Types.Severity }> };

export type EnergyConsumptionQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  mediums: Array<Types.MediumType> | Types.MediumType;
  current: Types.DataQueryFiltersInput;
  previous: Types.DataQueryFiltersInput;
}>;


export type EnergyConsumptionQuery = { consumption: { data: Array<{ unit: Types.CombinedUnit, data: Array<{ value: number }> }> }, previous: { data: Array<{ unit: Types.CombinedUnit, data: Array<{ value: number }> }> }, costs: { data: Array<{ unit: Types.CombinedUnit, data: Array<{ value: number }> }> } };

export type IndoorClimateScoresQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  dataFilters: Types.DataQueryFiltersInput;
}>;


export type IndoorClimateScoresQuery = { spacesStatistics: Array<{ space: { id: string }, scoreData: Array<{ scoreType: Types.ScoreType, average: number | null, scoreThresholdInfoSet: { displayUnit: string } | null, aggregatedDataScoreInfo: { name: string, hexColor: string } | null }> }> };

export type InstallationsScoreQueryVariables = Exact<{
  spaceId: string;
  spaceType: Types.SpaceType;
  systemTypes: Array<Types.SystemsType> | Types.SystemsType;
  dataFilters: Types.DataQueryFiltersInput;
}>;


export type InstallationsScoreQuery = { systemsOrSubsystemsScoreBySpace: Array<{ score: number | null }> };

export type SpaceSelectDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SpaceSelectDataQuery = { spaceTree: Array<{ id: string, name: string, parentId: string | null, type: Types.SpaceType }> };


export const AiAlarmsCountDocument = gql`
    query AiAlarmsCount($spaceId: String!, $spaceType: SpaceType!, $dataFilter: DataQueryFiltersInput) {
  alarmsCount(
    where: {spaceId: $spaceId, spaceType: $spaceType, dataFilter: $dataFilter}
  ) {
    active {
      count
      findings
    }
    inactive {
      count
      findings
    }
  }
}
    `;

/**
 * __useAiAlarmsCountQuery__
 *
 * To run a query within a React component, call `useAiAlarmsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAlarmsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiAlarmsCountQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      dataFilter: // value for 'dataFilter'
 *   },
 * });
 */
export function useAiAlarmsCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiAlarmsCountQuery, AiAlarmsCountQueryVariables> & ({ variables: AiAlarmsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>(AiAlarmsCountDocument, options);
      }
export function useAiAlarmsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>(AiAlarmsCountDocument, options);
        }
// @ts-ignore
export function useAiAlarmsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>;
export function useAiAlarmsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmsCountQuery | undefined, AiAlarmsCountQueryVariables>;
export function useAiAlarmsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>(AiAlarmsCountDocument, options);
        }
export type AiAlarmsCountQueryHookResult = ReturnType<typeof useAiAlarmsCountQuery>;
export type AiAlarmsCountLazyQueryHookResult = ReturnType<typeof useAiAlarmsCountLazyQuery>;
export type AiAlarmsCountSuspenseQueryHookResult = ReturnType<typeof useAiAlarmsCountSuspenseQuery>;
export type AiAlarmsCountQueryResult = ApolloReactCommon.QueryResult<AiAlarmsCountQuery, AiAlarmsCountQueryVariables>;
export const AiAlarmsDocument = gql`
    query AiAlarms($filters: AlarmsFilterInput!) {
  alarms(where: $filters) {
    id
    ruleId
    type
    isActive
    severity
    hasFindings
    date
    system
    spaces {
      id
      name
      type
    }
    ruleLogicType
    ruleLogicCategory
    installations {
      id
      name
      type
      category
      parentId
      controlLoop {
        id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useAiAlarmsQuery__
 *
 * To run a query within a React component, call `useAiAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiAlarmsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAiAlarmsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiAlarmsQuery, AiAlarmsQueryVariables> & ({ variables: AiAlarmsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiAlarmsQuery, AiAlarmsQueryVariables>(AiAlarmsDocument, options);
      }
export function useAiAlarmsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiAlarmsQuery, AiAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiAlarmsQuery, AiAlarmsQueryVariables>(AiAlarmsDocument, options);
        }
// @ts-ignore
export function useAiAlarmsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmsQuery, AiAlarmsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmsQuery, AiAlarmsQueryVariables>;
export function useAiAlarmsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmsQuery, AiAlarmsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmsQuery | undefined, AiAlarmsQueryVariables>;
export function useAiAlarmsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmsQuery, AiAlarmsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiAlarmsQuery, AiAlarmsQueryVariables>(AiAlarmsDocument, options);
        }
export type AiAlarmsQueryHookResult = ReturnType<typeof useAiAlarmsQuery>;
export type AiAlarmsLazyQueryHookResult = ReturnType<typeof useAiAlarmsLazyQuery>;
export type AiAlarmsSuspenseQueryHookResult = ReturnType<typeof useAiAlarmsSuspenseQuery>;
export type AiAlarmsQueryResult = ApolloReactCommon.QueryResult<AiAlarmsQuery, AiAlarmsQueryVariables>;
export const AiAlarmDurationsDocument = gql`
    query AiAlarmDurations($where: AlarmsFilterInput!) {
  alarmTimelineStatistics(where: $where) {
    startDate
    endDate
    alarms {
      type
      isActive
      severity
      hasFindings
      date
      system
      spaces {
        id
        name
        type
      }
      ruleLogicType
      ruleLogicCategory
      installations {
        id
        name
        type
        category
        parentId
        controlLoop {
          id
          name
          type
        }
      }
      timelineStatistics {
        totalActiveDurationMinutes
        totalAlertCount
      }
    }
  }
}
    `;

/**
 * __useAiAlarmDurationsQuery__
 *
 * To run a query within a React component, call `useAiAlarmDurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAlarmDurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiAlarmDurationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAiAlarmDurationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables> & ({ variables: AiAlarmDurationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>(AiAlarmDurationsDocument, options);
      }
export function useAiAlarmDurationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>(AiAlarmDurationsDocument, options);
        }
// @ts-ignore
export function useAiAlarmDurationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>;
export function useAiAlarmDurationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmDurationsQuery | undefined, AiAlarmDurationsQueryVariables>;
export function useAiAlarmDurationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>(AiAlarmDurationsDocument, options);
        }
export type AiAlarmDurationsQueryHookResult = ReturnType<typeof useAiAlarmDurationsQuery>;
export type AiAlarmDurationsLazyQueryHookResult = ReturnType<typeof useAiAlarmDurationsLazyQuery>;
export type AiAlarmDurationsSuspenseQueryHookResult = ReturnType<typeof useAiAlarmDurationsSuspenseQuery>;
export type AiAlarmDurationsQueryResult = ApolloReactCommon.QueryResult<AiAlarmDurationsQuery, AiAlarmDurationsQueryVariables>;
export const AiAlarmFindingsDocument = gql`
    query AiAlarmFindings($ruleId: ID!) {
  findingsByRuleId(ruleId: $ruleId) {
    id
    analysis
    followUpActions
    createdAt
    notifiedGroups
    findingState
    author {
      id
      name
    }
  }
}
    `;

/**
 * __useAiAlarmFindingsQuery__
 *
 * To run a query within a React component, call `useAiAlarmFindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAlarmFindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiAlarmFindingsQuery({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useAiAlarmFindingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables> & ({ variables: AiAlarmFindingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>(AiAlarmFindingsDocument, options);
      }
export function useAiAlarmFindingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>(AiAlarmFindingsDocument, options);
        }
// @ts-ignore
export function useAiAlarmFindingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>;
export function useAiAlarmFindingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmFindingsQuery | undefined, AiAlarmFindingsQueryVariables>;
export function useAiAlarmFindingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>(AiAlarmFindingsDocument, options);
        }
export type AiAlarmFindingsQueryHookResult = ReturnType<typeof useAiAlarmFindingsQuery>;
export type AiAlarmFindingsLazyQueryHookResult = ReturnType<typeof useAiAlarmFindingsLazyQuery>;
export type AiAlarmFindingsSuspenseQueryHookResult = ReturnType<typeof useAiAlarmFindingsSuspenseQuery>;
export type AiAlarmFindingsQueryResult = ApolloReactCommon.QueryResult<AiAlarmFindingsQuery, AiAlarmFindingsQueryVariables>;
export const AiAlarmFindingTimelineDocument = gql`
    query AiAlarmFindingTimeline($input: FindingTimelineInput!) {
  findingTimeline(input: $input) {
    totalCount
    items {
      userId
      userName
      createdAt
      type
      context {
        ... on FindingComment {
          id
          text
          createdAt
        }
        ... on FindingStatusChange {
          from
          to
        }
      }
    }
  }
}
    `;

/**
 * __useAiAlarmFindingTimelineQuery__
 *
 * To run a query within a React component, call `useAiAlarmFindingTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAlarmFindingTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiAlarmFindingTimelineQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiAlarmFindingTimelineQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables> & ({ variables: AiAlarmFindingTimelineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>(AiAlarmFindingTimelineDocument, options);
      }
export function useAiAlarmFindingTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>(AiAlarmFindingTimelineDocument, options);
        }
// @ts-ignore
export function useAiAlarmFindingTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>;
export function useAiAlarmFindingTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiAlarmFindingTimelineQuery | undefined, AiAlarmFindingTimelineQueryVariables>;
export function useAiAlarmFindingTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>(AiAlarmFindingTimelineDocument, options);
        }
export type AiAlarmFindingTimelineQueryHookResult = ReturnType<typeof useAiAlarmFindingTimelineQuery>;
export type AiAlarmFindingTimelineLazyQueryHookResult = ReturnType<typeof useAiAlarmFindingTimelineLazyQuery>;
export type AiAlarmFindingTimelineSuspenseQueryHookResult = ReturnType<typeof useAiAlarmFindingTimelineSuspenseQuery>;
export type AiAlarmFindingTimelineQueryResult = ApolloReactCommon.QueryResult<AiAlarmFindingTimelineQuery, AiAlarmFindingTimelineQueryVariables>;
export const AiEnergyConsumptionDocument = gql`
    query AiEnergyConsumption($dataFilters: DataQueryFiltersInput!, $spaceId: String!, $spaceType: SpaceType!, $dataType: DataType!, $mediums: [MediumType!]!, $splitBy: SplitByType!) {
  energyDataByType(
    where: {splitBy: $splitBy, dataFilters: $dataFilters, space: {id: $spaceId, type: $spaceType}, dataType: $dataType, mediums: $mediums}
  ) {
    data {
      data {
        value
        timeStamp
      }
      unit
      splitLabel {
        mediumType
        source
        name
      }
    }
    selectedInterval
  }
}
    `;

/**
 * __useAiEnergyConsumptionQuery__
 *
 * To run a query within a React component, call `useAiEnergyConsumptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiEnergyConsumptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiEnergyConsumptionQuery({
 *   variables: {
 *      dataFilters: // value for 'dataFilters'
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      dataType: // value for 'dataType'
 *      mediums: // value for 'mediums'
 *      splitBy: // value for 'splitBy'
 *   },
 * });
 */
export function useAiEnergyConsumptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables> & ({ variables: AiEnergyConsumptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>(AiEnergyConsumptionDocument, options);
      }
export function useAiEnergyConsumptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>(AiEnergyConsumptionDocument, options);
        }
// @ts-ignore
export function useAiEnergyConsumptionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>;
export function useAiEnergyConsumptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiEnergyConsumptionQuery | undefined, AiEnergyConsumptionQueryVariables>;
export function useAiEnergyConsumptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>(AiEnergyConsumptionDocument, options);
        }
export type AiEnergyConsumptionQueryHookResult = ReturnType<typeof useAiEnergyConsumptionQuery>;
export type AiEnergyConsumptionLazyQueryHookResult = ReturnType<typeof useAiEnergyConsumptionLazyQuery>;
export type AiEnergyConsumptionSuspenseQueryHookResult = ReturnType<typeof useAiEnergyConsumptionSuspenseQuery>;
export type AiEnergyConsumptionQueryResult = ApolloReactCommon.QueryResult<AiEnergyConsumptionQuery, AiEnergyConsumptionQueryVariables>;
export const AiEnergyMeterReadingsDocument = gql`
    query AiEnergyMeterReadings($dataFilters: DataQueryFiltersInput!, $spaceId: String!, $spaceType: SpaceType!, $mediums: [MediumType!]!, $meterCategory: MeterCategory!, $meterDataResultType: MeterDataResultType!, $mode: MeterDataMode!) {
  energyMeterDataQuery(
    where: {dataFilters: $dataFilters, mediums: $mediums, meterCategory: $meterCategory, meterDataResultType: $meterDataResultType, mode: $mode, space: {id: $spaceId, type: $spaceType}}
  ) {
    meterData {
      spaces {
        site {
          name
        }
        building {
          name
        }
        subBuilding {
          name
        }
        level {
          name
        }
        room {
          name
        }
      }
      mediumType
      unit
      datapointName
      meter {
        id
        name
      }
      data {
        value
        timeStamp
      }
    }
  }
}
    `;

/**
 * __useAiEnergyMeterReadingsQuery__
 *
 * To run a query within a React component, call `useAiEnergyMeterReadingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiEnergyMeterReadingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiEnergyMeterReadingsQuery({
 *   variables: {
 *      dataFilters: // value for 'dataFilters'
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      mediums: // value for 'mediums'
 *      meterCategory: // value for 'meterCategory'
 *      meterDataResultType: // value for 'meterDataResultType'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useAiEnergyMeterReadingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables> & ({ variables: AiEnergyMeterReadingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>(AiEnergyMeterReadingsDocument, options);
      }
export function useAiEnergyMeterReadingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>(AiEnergyMeterReadingsDocument, options);
        }
// @ts-ignore
export function useAiEnergyMeterReadingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>;
export function useAiEnergyMeterReadingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiEnergyMeterReadingsQuery | undefined, AiEnergyMeterReadingsQueryVariables>;
export function useAiEnergyMeterReadingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>(AiEnergyMeterReadingsDocument, options);
        }
export type AiEnergyMeterReadingsQueryHookResult = ReturnType<typeof useAiEnergyMeterReadingsQuery>;
export type AiEnergyMeterReadingsLazyQueryHookResult = ReturnType<typeof useAiEnergyMeterReadingsLazyQuery>;
export type AiEnergyMeterReadingsSuspenseQueryHookResult = ReturnType<typeof useAiEnergyMeterReadingsSuspenseQuery>;
export type AiEnergyMeterReadingsQueryResult = ApolloReactCommon.QueryResult<AiEnergyMeterReadingsQuery, AiEnergyMeterReadingsQueryVariables>;
export const AiEnergyRegressionDocument = gql`
    query AiEnergyRegression($regressionWhere: EnergyRegressionInput!) {
  energyRegressionQuery(where: $regressionWhere) {
    intervals
    selectedInterval
    series {
      gap
      data {
        timestamp
        value1
        value2
      }
    }
  }
}
    `;

/**
 * __useAiEnergyRegressionQuery__
 *
 * To run a query within a React component, call `useAiEnergyRegressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiEnergyRegressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiEnergyRegressionQuery({
 *   variables: {
 *      regressionWhere: // value for 'regressionWhere'
 *   },
 * });
 */
export function useAiEnergyRegressionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables> & ({ variables: AiEnergyRegressionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>(AiEnergyRegressionDocument, options);
      }
export function useAiEnergyRegressionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>(AiEnergyRegressionDocument, options);
        }
// @ts-ignore
export function useAiEnergyRegressionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>;
export function useAiEnergyRegressionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiEnergyRegressionQuery | undefined, AiEnergyRegressionQueryVariables>;
export function useAiEnergyRegressionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>(AiEnergyRegressionDocument, options);
        }
export type AiEnergyRegressionQueryHookResult = ReturnType<typeof useAiEnergyRegressionQuery>;
export type AiEnergyRegressionLazyQueryHookResult = ReturnType<typeof useAiEnergyRegressionLazyQuery>;
export type AiEnergyRegressionSuspenseQueryHookResult = ReturnType<typeof useAiEnergyRegressionSuspenseQuery>;
export type AiEnergyRegressionQueryResult = ApolloReactCommon.QueryResult<AiEnergyRegressionQuery, AiEnergyRegressionQueryVariables>;
export const AiIndoorClimateScoresDocument = gql`
    query AiIndoorClimateScores($dataFilters: DataQueryFiltersInput!, $spaceId: String!, $spaceType: SpaceType!, $scoreSpaceType: SpaceType!, $scoreTypes: [ScoreType!]!, $standardId: Int) {
  spacesStatistics(
    where: {dataFilters: $dataFilters, space: {id: $spaceId, type: $spaceType}, spaceType: $scoreSpaceType, scoreTypes: $scoreTypes, standardId: $standardId}
  ) {
    space {
      id
      name
      type
    }
    spaces {
      id
      name
      type
    }
    scoreData {
      scoreType
      average
      min
      max
      aggregatedDataScoreInfo {
        name
        positionPercentage
      }
    }
  }
}
    `;

/**
 * __useAiIndoorClimateScoresQuery__
 *
 * To run a query within a React component, call `useAiIndoorClimateScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiIndoorClimateScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiIndoorClimateScoresQuery({
 *   variables: {
 *      dataFilters: // value for 'dataFilters'
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      scoreSpaceType: // value for 'scoreSpaceType'
 *      scoreTypes: // value for 'scoreTypes'
 *      standardId: // value for 'standardId'
 *   },
 * });
 */
export function useAiIndoorClimateScoresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables> & ({ variables: AiIndoorClimateScoresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>(AiIndoorClimateScoresDocument, options);
      }
export function useAiIndoorClimateScoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>(AiIndoorClimateScoresDocument, options);
        }
// @ts-ignore
export function useAiIndoorClimateScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>;
export function useAiIndoorClimateScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndoorClimateScoresQuery | undefined, AiIndoorClimateScoresQueryVariables>;
export function useAiIndoorClimateScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>(AiIndoorClimateScoresDocument, options);
        }
export type AiIndoorClimateScoresQueryHookResult = ReturnType<typeof useAiIndoorClimateScoresQuery>;
export type AiIndoorClimateScoresLazyQueryHookResult = ReturnType<typeof useAiIndoorClimateScoresLazyQuery>;
export type AiIndoorClimateScoresSuspenseQueryHookResult = ReturnType<typeof useAiIndoorClimateScoresSuspenseQuery>;
export type AiIndoorClimateScoresQueryResult = ApolloReactCommon.QueryResult<AiIndoorClimateScoresQuery, AiIndoorClimateScoresQueryVariables>;
export const AiIndoorClimateStandardsBySpaceDocument = gql`
    query AiIndoorClimateStandardsBySpace($spaceId: String!) {
  indoorClimateStandards(externalId: $spaceId) {
    standardId
    key
    name
    indoorClimateStandardType
  }
}
    `;

/**
 * __useAiIndoorClimateStandardsBySpaceQuery__
 *
 * To run a query within a React component, call `useAiIndoorClimateStandardsBySpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiIndoorClimateStandardsBySpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiIndoorClimateStandardsBySpaceQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *   },
 * });
 */
export function useAiIndoorClimateStandardsBySpaceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables> & ({ variables: AiIndoorClimateStandardsBySpaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>(AiIndoorClimateStandardsBySpaceDocument, options);
      }
export function useAiIndoorClimateStandardsBySpaceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>(AiIndoorClimateStandardsBySpaceDocument, options);
        }
// @ts-ignore
export function useAiIndoorClimateStandardsBySpaceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>;
export function useAiIndoorClimateStandardsBySpaceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndoorClimateStandardsBySpaceQuery | undefined, AiIndoorClimateStandardsBySpaceQueryVariables>;
export function useAiIndoorClimateStandardsBySpaceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>(AiIndoorClimateStandardsBySpaceDocument, options);
        }
export type AiIndoorClimateStandardsBySpaceQueryHookResult = ReturnType<typeof useAiIndoorClimateStandardsBySpaceQuery>;
export type AiIndoorClimateStandardsBySpaceLazyQueryHookResult = ReturnType<typeof useAiIndoorClimateStandardsBySpaceLazyQuery>;
export type AiIndoorClimateStandardsBySpaceSuspenseQueryHookResult = ReturnType<typeof useAiIndoorClimateStandardsBySpaceSuspenseQuery>;
export type AiIndoorClimateStandardsBySpaceQueryResult = ApolloReactCommon.QueryResult<AiIndoorClimateStandardsBySpaceQuery, AiIndoorClimateStandardsBySpaceQueryVariables>;
export const AiIndoorClimateScoreTimeseriesDocument = gql`
    query AiIndoorClimateScoreTimeseries($spaceId: String!, $spaceType: SpaceType!, $aggregationScoreType: ScoreType!, $dataFilters: DataQueryFiltersInput!, $standardId: Int) {
  scoreTimeseriesBySpace(
    where: {spaceId: $spaceId, spaceType: $spaceType, aggregationScoreType: $aggregationScoreType, dataFilters: $dataFilters, standardId: $standardId}
  ) {
    timeseriesInfos {
      timeseriesId
      data {
        timestamp
        value
        aggregatedDataScoreInfo {
          positionPercentage
          name
        }
        valueMin
        valueMax
        valueCount
      }
      scoreThresholdInfoSet {
        scoreThresholdInfos {
          hexColor
          start
          startPercentage
          end
          endPercentage
          name
        }
        displayUnit
      }
    }
  }
}
    `;

/**
 * __useAiIndoorClimateScoreTimeseriesQuery__
 *
 * To run a query within a React component, call `useAiIndoorClimateScoreTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiIndoorClimateScoreTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiIndoorClimateScoreTimeseriesQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      aggregationScoreType: // value for 'aggregationScoreType'
 *      dataFilters: // value for 'dataFilters'
 *      standardId: // value for 'standardId'
 *   },
 * });
 */
export function useAiIndoorClimateScoreTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables> & ({ variables: AiIndoorClimateScoreTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>(AiIndoorClimateScoreTimeseriesDocument, options);
      }
export function useAiIndoorClimateScoreTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>(AiIndoorClimateScoreTimeseriesDocument, options);
        }
// @ts-ignore
export function useAiIndoorClimateScoreTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>;
export function useAiIndoorClimateScoreTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiIndoorClimateScoreTimeseriesQuery | undefined, AiIndoorClimateScoreTimeseriesQueryVariables>;
export function useAiIndoorClimateScoreTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>(AiIndoorClimateScoreTimeseriesDocument, options);
        }
export type AiIndoorClimateScoreTimeseriesQueryHookResult = ReturnType<typeof useAiIndoorClimateScoreTimeseriesQuery>;
export type AiIndoorClimateScoreTimeseriesLazyQueryHookResult = ReturnType<typeof useAiIndoorClimateScoreTimeseriesLazyQuery>;
export type AiIndoorClimateScoreTimeseriesSuspenseQueryHookResult = ReturnType<typeof useAiIndoorClimateScoreTimeseriesSuspenseQuery>;
export type AiIndoorClimateScoreTimeseriesQueryResult = ApolloReactCommon.QueryResult<AiIndoorClimateScoreTimeseriesQuery, AiIndoorClimateScoreTimeseriesQueryVariables>;
export const AiInstallationSystemsScoreDocument = gql`
    query AiInstallationSystemsScore($spaceId: String!, $spaceType: SpaceType!, $dataFilters: DataQueryFiltersInput!) {
  systemsScoreBySpace(
    where: {space: {id: $spaceId, type: $spaceType}, dataFilters: $dataFilters}
  ) {
    systemType
    score
  }
}
    `;

/**
 * __useAiInstallationSystemsScoreQuery__
 *
 * To run a query within a React component, call `useAiInstallationSystemsScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiInstallationSystemsScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiInstallationSystemsScoreQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      dataFilters: // value for 'dataFilters'
 *   },
 * });
 */
export function useAiInstallationSystemsScoreQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables> & ({ variables: AiInstallationSystemsScoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>(AiInstallationSystemsScoreDocument, options);
      }
export function useAiInstallationSystemsScoreLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>(AiInstallationSystemsScoreDocument, options);
        }
// @ts-ignore
export function useAiInstallationSystemsScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>;
export function useAiInstallationSystemsScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiInstallationSystemsScoreQuery | undefined, AiInstallationSystemsScoreQueryVariables>;
export function useAiInstallationSystemsScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>(AiInstallationSystemsScoreDocument, options);
        }
export type AiInstallationSystemsScoreQueryHookResult = ReturnType<typeof useAiInstallationSystemsScoreQuery>;
export type AiInstallationSystemsScoreLazyQueryHookResult = ReturnType<typeof useAiInstallationSystemsScoreLazyQuery>;
export type AiInstallationSystemsScoreSuspenseQueryHookResult = ReturnType<typeof useAiInstallationSystemsScoreSuspenseQuery>;
export type AiInstallationSystemsScoreQueryResult = ApolloReactCommon.QueryResult<AiInstallationSystemsScoreQuery, AiInstallationSystemsScoreQueryVariables>;
export const AiInstallationSystemsListDocument = gql`
    query AiInstallationSystemsList($spaceId: String!, $spaceType: SpaceType!, $systemTypes: [SystemsType!]!, $dataFilters: DataQueryFiltersInput!) {
  systemsOrSubsystemsScoreBySpace(
    where: {space: {id: $spaceId, type: $spaceType}, systemTypes: $systemTypes, dataFilters: $dataFilters}
  ) {
    system {
      id
      name
      type
    }
    subsystem {
      id
      name
      type
    }
    spaces {
      id
      name
    }
    systemType
    score
  }
}
    `;

/**
 * __useAiInstallationSystemsListQuery__
 *
 * To run a query within a React component, call `useAiInstallationSystemsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiInstallationSystemsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiInstallationSystemsListQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      systemTypes: // value for 'systemTypes'
 *      dataFilters: // value for 'dataFilters'
 *   },
 * });
 */
export function useAiInstallationSystemsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables> & ({ variables: AiInstallationSystemsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>(AiInstallationSystemsListDocument, options);
      }
export function useAiInstallationSystemsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>(AiInstallationSystemsListDocument, options);
        }
// @ts-ignore
export function useAiInstallationSystemsListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>;
export function useAiInstallationSystemsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiInstallationSystemsListQuery | undefined, AiInstallationSystemsListQueryVariables>;
export function useAiInstallationSystemsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>(AiInstallationSystemsListDocument, options);
        }
export type AiInstallationSystemsListQueryHookResult = ReturnType<typeof useAiInstallationSystemsListQuery>;
export type AiInstallationSystemsListLazyQueryHookResult = ReturnType<typeof useAiInstallationSystemsListLazyQuery>;
export type AiInstallationSystemsListSuspenseQueryHookResult = ReturnType<typeof useAiInstallationSystemsListSuspenseQuery>;
export type AiInstallationSystemsListQueryResult = ApolloReactCommon.QueryResult<AiInstallationSystemsListQuery, AiInstallationSystemsListQueryVariables>;
export const AiInstallationPartsScoresDocument = gql`
    query AiInstallationPartsScores($system: SystemInput!, $subsystem: SubsystemInput, $dataFilters: DataQueryFiltersInput!) {
  systemOrSubsystemInstallationPartsScores(
    where: {system: $system, subsystem: $subsystem, dataFilters: $dataFilters, categoryScores: [{category: CONTROL_LOOP, scoreTypes: [], scoreTypeAggregations: [{scoreType: ACCURACY}]}, {category: COMPONENTS, scoreTypeAggregations: [{scoreType: STABILITY}, {scoreType: OPERATING_HOURS, aggregationTypeOverride: SUM}, {scoreType: START_STOP_COUNT, aggregationTypeOverride: SUM}]}, {category: SENSORS, scoreTypeAggregations: [{scoreType: STABILITY}, {scoreType: ONLINE_STATUS}]}, {category: ACTUATORS, scoreTypeAggregations: [{scoreType: STABILITY}]}]}
  ) {
    category
    installationPartScores {
      installationPart {
        id
        name
        ... on InstallationPartPoint {
          pointType: type
          timeseriesId
          isOnline
          metadata {
            protocolType
            ... on BacnetMetadata {
              objectName
              description
              deviceInstance
              objectType
              objectInstance
              unitText
            }
          }
        }
        ... on InstallationPartEquipment {
          equipmentType: type
          points {
            id
            name
            type
            timeseriesId
          }
        }
        ... on InstallationPartControlLoop {
          points {
            id
            name
            type
            timeseriesId
            metadata {
              protocolType
              ... on BacnetMetadata {
                objectName
                description
                deviceInstance
                objectType
                objectInstance
              }
            }
          }
        }
      }
      scores {
        scoreType
        value
      }
      value
    }
  }
}
    `;

/**
 * __useAiInstallationPartsScoresQuery__
 *
 * To run a query within a React component, call `useAiInstallationPartsScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiInstallationPartsScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiInstallationPartsScoresQuery({
 *   variables: {
 *      system: // value for 'system'
 *      subsystem: // value for 'subsystem'
 *      dataFilters: // value for 'dataFilters'
 *   },
 * });
 */
export function useAiInstallationPartsScoresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables> & ({ variables: AiInstallationPartsScoresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>(AiInstallationPartsScoresDocument, options);
      }
export function useAiInstallationPartsScoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>(AiInstallationPartsScoresDocument, options);
        }
// @ts-ignore
export function useAiInstallationPartsScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>;
export function useAiInstallationPartsScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiInstallationPartsScoresQuery | undefined, AiInstallationPartsScoresQueryVariables>;
export function useAiInstallationPartsScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>(AiInstallationPartsScoresDocument, options);
        }
export type AiInstallationPartsScoresQueryHookResult = ReturnType<typeof useAiInstallationPartsScoresQuery>;
export type AiInstallationPartsScoresLazyQueryHookResult = ReturnType<typeof useAiInstallationPartsScoresLazyQuery>;
export type AiInstallationPartsScoresSuspenseQueryHookResult = ReturnType<typeof useAiInstallationPartsScoresSuspenseQuery>;
export type AiInstallationPartsScoresQueryResult = ApolloReactCommon.QueryResult<AiInstallationPartsScoresQuery, AiInstallationPartsScoresQueryVariables>;
export const AiSensorTimeseriesDocument = gql`
    query AiSensorTimeseries($spaceId: String!, $spaceType: SpaceType!, $sensorType: PointsType!, $dataFilters: DataQueryFiltersInput!) {
  sensorTimeseriesBySpaceAndType(
    sort: {direction: DESCENDING}
    where: {spaceId: $spaceId, spaceType: $spaceType, sensorType: $sensorType, dataFilters: $dataFilters, resolutionType: TOWARDS_ROOT_AND_LEAF}
  ) {
    spaceTimeseriesInfos {
      space {
        id
        name
      }
      data {
        timestamp
        value
      }
    }
  }
}
    `;

/**
 * __useAiSensorTimeseriesQuery__
 *
 * To run a query within a React component, call `useAiSensorTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSensorTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSensorTimeseriesQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      sensorType: // value for 'sensorType'
 *      dataFilters: // value for 'dataFilters'
 *   },
 * });
 */
export function useAiSensorTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables> & ({ variables: AiSensorTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>(AiSensorTimeseriesDocument, options);
      }
export function useAiSensorTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>(AiSensorTimeseriesDocument, options);
        }
// @ts-ignore
export function useAiSensorTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>;
export function useAiSensorTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSensorTimeseriesQuery | undefined, AiSensorTimeseriesQueryVariables>;
export function useAiSensorTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>(AiSensorTimeseriesDocument, options);
        }
export type AiSensorTimeseriesQueryHookResult = ReturnType<typeof useAiSensorTimeseriesQuery>;
export type AiSensorTimeseriesLazyQueryHookResult = ReturnType<typeof useAiSensorTimeseriesLazyQuery>;
export type AiSensorTimeseriesSuspenseQueryHookResult = ReturnType<typeof useAiSensorTimeseriesSuspenseQuery>;
export type AiSensorTimeseriesQueryResult = ApolloReactCommon.QueryResult<AiSensorTimeseriesQuery, AiSensorTimeseriesQueryVariables>;
export const AiSpaceListDocument = gql`
    query AiSpaceList {
  spaceTree {
    id
    name
    parentId
    type
  }
}
    `;

/**
 * __useAiSpaceListQuery__
 *
 * To run a query within a React component, call `useAiSpaceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSpaceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSpaceListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiSpaceListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiSpaceListQuery, AiSpaceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiSpaceListQuery, AiSpaceListQueryVariables>(AiSpaceListDocument, options);
      }
export function useAiSpaceListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiSpaceListQuery, AiSpaceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiSpaceListQuery, AiSpaceListQueryVariables>(AiSpaceListDocument, options);
        }
// @ts-ignore
export function useAiSpaceListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiSpaceListQuery, AiSpaceListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSpaceListQuery, AiSpaceListQueryVariables>;
export function useAiSpaceListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSpaceListQuery, AiSpaceListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSpaceListQuery | undefined, AiSpaceListQueryVariables>;
export function useAiSpaceListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSpaceListQuery, AiSpaceListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiSpaceListQuery, AiSpaceListQueryVariables>(AiSpaceListDocument, options);
        }
export type AiSpaceListQueryHookResult = ReturnType<typeof useAiSpaceListQuery>;
export type AiSpaceListLazyQueryHookResult = ReturnType<typeof useAiSpaceListLazyQuery>;
export type AiSpaceListSuspenseQueryHookResult = ReturnType<typeof useAiSpaceListSuspenseQuery>;
export type AiSpaceListQueryResult = ApolloReactCommon.QueryResult<AiSpaceListQuery, AiSpaceListQueryVariables>;
export const EmissionsDataDocument = gql`
    query EmissionsData($dataFilters: DataQueryFiltersInput!, $spaceId: String!, $spaceType: SpaceType!, $dataType: DataType!, $mediums: [MediumType!]!, $splitBy: SplitByType!) {
  energyDataByType(
    where: {splitBy: $splitBy, dataFilters: $dataFilters, space: {id: $spaceId, type: $spaceType}, dataType: $dataType, mediums: $mediums}
  ) {
    data {
      data {
        value
        timeStamp
      }
      unit
    }
  }
}
    `;

/**
 * __useEmissionsDataQuery__
 *
 * To run a query within a React component, call `useEmissionsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmissionsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmissionsDataQuery({
 *   variables: {
 *      dataFilters: // value for 'dataFilters'
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      dataType: // value for 'dataType'
 *      mediums: // value for 'mediums'
 *      splitBy: // value for 'splitBy'
 *   },
 * });
 */
export function useEmissionsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EmissionsDataQuery, EmissionsDataQueryVariables> & ({ variables: EmissionsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EmissionsDataQuery, EmissionsDataQueryVariables>(EmissionsDataDocument, options);
      }
export function useEmissionsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmissionsDataQuery, EmissionsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EmissionsDataQuery, EmissionsDataQueryVariables>(EmissionsDataDocument, options);
        }
// @ts-ignore
export function useEmissionsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EmissionsDataQuery, EmissionsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EmissionsDataQuery, EmissionsDataQueryVariables>;
export function useEmissionsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EmissionsDataQuery, EmissionsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EmissionsDataQuery | undefined, EmissionsDataQueryVariables>;
export function useEmissionsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EmissionsDataQuery, EmissionsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EmissionsDataQuery, EmissionsDataQueryVariables>(EmissionsDataDocument, options);
        }
export type EmissionsDataQueryHookResult = ReturnType<typeof useEmissionsDataQuery>;
export type EmissionsDataLazyQueryHookResult = ReturnType<typeof useEmissionsDataLazyQuery>;
export type EmissionsDataSuspenseQueryHookResult = ReturnType<typeof useEmissionsDataSuspenseQuery>;
export type EmissionsDataQueryResult = ApolloReactCommon.QueryResult<EmissionsDataQuery, EmissionsDataQueryVariables>;
export const EnergyGenerationDataDocument = gql`
    query EnergyGenerationData($dataFilters: DataQueryFiltersInput!, $spaceId: String!, $spaceType: SpaceType!, $dataType: DataType!, $mediums: [MediumType!]!, $splitBy: SplitByType!) {
  energyDataByType(
    where: {splitBy: $splitBy, dataFilters: $dataFilters, space: {id: $spaceId, type: $spaceType}, dataType: $dataType, mediums: $mediums}
  ) {
    data {
      data {
        value
      }
      unit
      splitLabel {
        mediumType
        source
        name
      }
    }
  }
}
    `;

/**
 * __useEnergyGenerationDataQuery__
 *
 * To run a query within a React component, call `useEnergyGenerationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyGenerationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyGenerationDataQuery({
 *   variables: {
 *      dataFilters: // value for 'dataFilters'
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      dataType: // value for 'dataType'
 *      mediums: // value for 'mediums'
 *      splitBy: // value for 'splitBy'
 *   },
 * });
 */
export function useEnergyGenerationDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables> & ({ variables: EnergyGenerationDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>(EnergyGenerationDataDocument, options);
      }
export function useEnergyGenerationDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>(EnergyGenerationDataDocument, options);
        }
// @ts-ignore
export function useEnergyGenerationDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>;
export function useEnergyGenerationDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnergyGenerationDataQuery | undefined, EnergyGenerationDataQueryVariables>;
export function useEnergyGenerationDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>(EnergyGenerationDataDocument, options);
        }
export type EnergyGenerationDataQueryHookResult = ReturnType<typeof useEnergyGenerationDataQuery>;
export type EnergyGenerationDataLazyQueryHookResult = ReturnType<typeof useEnergyGenerationDataLazyQuery>;
export type EnergyGenerationDataSuspenseQueryHookResult = ReturnType<typeof useEnergyGenerationDataSuspenseQuery>;
export type EnergyGenerationDataQueryResult = ApolloReactCommon.QueryResult<EnergyGenerationDataQuery, EnergyGenerationDataQueryVariables>;
export const AlarmsFindingsDocument = gql`
    query AlarmsFindings($spaceId: String!, $spaceType: SpaceType!, $limit: Int!) {
  alarmsCount(where: {spaceId: $spaceId, spaceType: $spaceType}) {
    active {
      count
      findings
    }
  }
  alarms(
    where: {spaceFilter: {id: $spaceId, type: $spaceType}, alarmDataFilter: {isActive: true}, pagination: {limit: $limit}}
  ) {
    severity
  }
}
    `;

/**
 * __useAlarmsFindingsQuery__
 *
 * To run a query within a React component, call `useAlarmsFindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlarmsFindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlarmsFindingsQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAlarmsFindingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AlarmsFindingsQuery, AlarmsFindingsQueryVariables> & ({ variables: AlarmsFindingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>(AlarmsFindingsDocument, options);
      }
export function useAlarmsFindingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>(AlarmsFindingsDocument, options);
        }
// @ts-ignore
export function useAlarmsFindingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>;
export function useAlarmsFindingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AlarmsFindingsQuery | undefined, AlarmsFindingsQueryVariables>;
export function useAlarmsFindingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>(AlarmsFindingsDocument, options);
        }
export type AlarmsFindingsQueryHookResult = ReturnType<typeof useAlarmsFindingsQuery>;
export type AlarmsFindingsLazyQueryHookResult = ReturnType<typeof useAlarmsFindingsLazyQuery>;
export type AlarmsFindingsSuspenseQueryHookResult = ReturnType<typeof useAlarmsFindingsSuspenseQuery>;
export type AlarmsFindingsQueryResult = ApolloReactCommon.QueryResult<AlarmsFindingsQuery, AlarmsFindingsQueryVariables>;
export const EnergyConsumptionDocument = gql`
    query EnergyConsumption($spaceId: String!, $spaceType: SpaceType!, $mediums: [MediumType!]!, $current: DataQueryFiltersInput!, $previous: DataQueryFiltersInput!) {
  consumption: energyDataByType(
    where: {space: {id: $spaceId, type: $spaceType}, mediums: $mediums, dataType: CONSUMPTION, splitBy: NONE, dataFilters: $current}
  ) {
    data {
      unit
      data {
        value
      }
    }
  }
  previous: energyDataByType(
    where: {space: {id: $spaceId, type: $spaceType}, mediums: $mediums, dataType: CONSUMPTION, splitBy: NONE, dataFilters: $previous}
  ) {
    data {
      unit
      data {
        value
      }
    }
  }
  costs: energyDataByType(
    where: {space: {id: $spaceId, type: $spaceType}, mediums: $mediums, dataType: COSTS, splitBy: NONE, dataFilters: $current}
  ) {
    data {
      unit
      data {
        value
      }
    }
  }
}
    `;

/**
 * __useEnergyConsumptionQuery__
 *
 * To run a query within a React component, call `useEnergyConsumptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConsumptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConsumptionQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      mediums: // value for 'mediums'
 *      current: // value for 'current'
 *      previous: // value for 'previous'
 *   },
 * });
 */
export function useEnergyConsumptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EnergyConsumptionQuery, EnergyConsumptionQueryVariables> & ({ variables: EnergyConsumptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>(EnergyConsumptionDocument, options);
      }
export function useEnergyConsumptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>(EnergyConsumptionDocument, options);
        }
// @ts-ignore
export function useEnergyConsumptionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>;
export function useEnergyConsumptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnergyConsumptionQuery | undefined, EnergyConsumptionQueryVariables>;
export function useEnergyConsumptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>(EnergyConsumptionDocument, options);
        }
export type EnergyConsumptionQueryHookResult = ReturnType<typeof useEnergyConsumptionQuery>;
export type EnergyConsumptionLazyQueryHookResult = ReturnType<typeof useEnergyConsumptionLazyQuery>;
export type EnergyConsumptionSuspenseQueryHookResult = ReturnType<typeof useEnergyConsumptionSuspenseQuery>;
export type EnergyConsumptionQueryResult = ApolloReactCommon.QueryResult<EnergyConsumptionQuery, EnergyConsumptionQueryVariables>;
export const IndoorClimateScoresDocument = gql`
    query IndoorClimateScores($spaceId: String!, $spaceType: SpaceType!, $dataFilters: DataQueryFiltersInput!) {
  spacesStatistics(
    where: {space: {id: $spaceId, type: $spaceType}, spaceType: $spaceType, scoreTypes: [TEMPERATURE, CO2, HUMIDITY], dataFilters: $dataFilters}
  ) {
    space {
      id
    }
    scoreData {
      scoreType
      average
      scoreThresholdInfoSet {
        displayUnit
      }
      aggregatedDataScoreInfo {
        name
        hexColor
      }
    }
  }
}
    `;

/**
 * __useIndoorClimateScoresQuery__
 *
 * To run a query within a React component, call `useIndoorClimateScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndoorClimateScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndoorClimateScoresQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      dataFilters: // value for 'dataFilters'
 *   },
 * });
 */
export function useIndoorClimateScoresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables> & ({ variables: IndoorClimateScoresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>(IndoorClimateScoresDocument, options);
      }
export function useIndoorClimateScoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>(IndoorClimateScoresDocument, options);
        }
// @ts-ignore
export function useIndoorClimateScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>;
export function useIndoorClimateScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IndoorClimateScoresQuery | undefined, IndoorClimateScoresQueryVariables>;
export function useIndoorClimateScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>(IndoorClimateScoresDocument, options);
        }
export type IndoorClimateScoresQueryHookResult = ReturnType<typeof useIndoorClimateScoresQuery>;
export type IndoorClimateScoresLazyQueryHookResult = ReturnType<typeof useIndoorClimateScoresLazyQuery>;
export type IndoorClimateScoresSuspenseQueryHookResult = ReturnType<typeof useIndoorClimateScoresSuspenseQuery>;
export type IndoorClimateScoresQueryResult = ApolloReactCommon.QueryResult<IndoorClimateScoresQuery, IndoorClimateScoresQueryVariables>;
export const InstallationsScoreDocument = gql`
    query InstallationsScore($spaceId: String!, $spaceType: SpaceType!, $systemTypes: [SystemsType!]!, $dataFilters: DataQueryFiltersInput!) {
  systemsOrSubsystemsScoreBySpace(
    where: {space: {id: $spaceId, type: $spaceType}, systemTypes: $systemTypes, dataFilters: $dataFilters}
  ) {
    score
  }
}
    `;

/**
 * __useInstallationsScoreQuery__
 *
 * To run a query within a React component, call `useInstallationsScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstallationsScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallationsScoreQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      spaceType: // value for 'spaceType'
 *      systemTypes: // value for 'systemTypes'
 *      dataFilters: // value for 'dataFilters'
 *   },
 * });
 */
export function useInstallationsScoreQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InstallationsScoreQuery, InstallationsScoreQueryVariables> & ({ variables: InstallationsScoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InstallationsScoreQuery, InstallationsScoreQueryVariables>(InstallationsScoreDocument, options);
      }
export function useInstallationsScoreLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstallationsScoreQuery, InstallationsScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InstallationsScoreQuery, InstallationsScoreQueryVariables>(InstallationsScoreDocument, options);
        }
// @ts-ignore
export function useInstallationsScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InstallationsScoreQuery, InstallationsScoreQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InstallationsScoreQuery, InstallationsScoreQueryVariables>;
export function useInstallationsScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InstallationsScoreQuery, InstallationsScoreQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InstallationsScoreQuery | undefined, InstallationsScoreQueryVariables>;
export function useInstallationsScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InstallationsScoreQuery, InstallationsScoreQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InstallationsScoreQuery, InstallationsScoreQueryVariables>(InstallationsScoreDocument, options);
        }
export type InstallationsScoreQueryHookResult = ReturnType<typeof useInstallationsScoreQuery>;
export type InstallationsScoreLazyQueryHookResult = ReturnType<typeof useInstallationsScoreLazyQuery>;
export type InstallationsScoreSuspenseQueryHookResult = ReturnType<typeof useInstallationsScoreSuspenseQuery>;
export type InstallationsScoreQueryResult = ApolloReactCommon.QueryResult<InstallationsScoreQuery, InstallationsScoreQueryVariables>;
export const SpaceSelectDataDocument = gql`
    query SpaceSelectData {
  spaceTree {
    id
    name
    parentId
    type
  }
}
    `;

/**
 * __useSpaceSelectDataQuery__
 *
 * To run a query within a React component, call `useSpaceSelectDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceSelectDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceSelectDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpaceSelectDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>(SpaceSelectDataDocument, options);
      }
export function useSpaceSelectDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>(SpaceSelectDataDocument, options);
        }
// @ts-ignore
export function useSpaceSelectDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>;
export function useSpaceSelectDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SpaceSelectDataQuery | undefined, SpaceSelectDataQueryVariables>;
export function useSpaceSelectDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>(SpaceSelectDataDocument, options);
        }
export type SpaceSelectDataQueryHookResult = ReturnType<typeof useSpaceSelectDataQuery>;
export type SpaceSelectDataLazyQueryHookResult = ReturnType<typeof useSpaceSelectDataLazyQuery>;
export type SpaceSelectDataSuspenseQueryHookResult = ReturnType<typeof useSpaceSelectDataSuspenseQuery>;
export type SpaceSelectDataQueryResult = ApolloReactCommon.QueryResult<SpaceSelectDataQuery, SpaceSelectDataQueryVariables>;